import { Component } from 'react';
import Banner from '../components/common/Banner';

export default class About extends Component {
  render() {
    return (
      <div>
        {/* Page Title */}
        <Banner title={"About"} desc={"Bhoomi Rock Products"} img={"images/bg/bg_1.jpg"} />

        {/* About Section */}
        <section className="section about-page">
          <div className="container">
            <div className="row">
              <div className="col-lg-4">
                <h2 className="title-color">Our Mission</h2>
              </div>
              <div className="col-lg-8">
                <p>
                  Bhoomi Rocks is dedicated to supplying the finest natural stones and minerals for construction, landscaping, and design. Our mission is to deliver quality, reliability, and beauty in every stone, helping you create spaces that inspire and endure.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Features */}
        <section>
          <div className="container">
            <div className="row">
              {[
                {
                  img: "images/about/about-1.jpg",
                  title: "Industry High Quality Standards",
                  desc: "Quality assurance with rigorous testing and certification."
                },
                {
                  img: "images/about/about-2.jpg",
                  title: "High-Performance Equipment",
                  desc: "Advanced machinery engineered for maximum efficiency."
                },
                {
                  img: "images/about/about-3.jpg",
                  title: "Environmental Sustainable Solutions",
                  desc: "Eco-friendly practices that reduce environmental impact."
                },
                {
                  img: "images/about/about-4.jpg",
                  title: "Customer-Centric Approach",
                  desc: "Tailored solutions designed to enhance productivity."
                }
              ].map((feature, index) => (
                <div key={index} className="col-lg-3 col-md-6">
                  <div className="about-block-item mb-5 mb-lg-0 text-center">
                    <img
                      src={feature.img}
                      alt={feature.title}
                      className="img-fluid w-100"
                    />
                    <h4 className="mt-3">{feature.title}</h4>
                    <p>{feature.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Details Section */}
        <section className="section about-page">
          <div className="container">
            <div className="row">
              <div className="col-lg-4">
                <h2 className="title-color">Who We Are</h2>
              </div>
              <div className="col-lg-8">
                <p>
                  Bhoomi Rocks Products is a partnership firm formed on May 22, 2023, under The Partnership Act, 1932, operating from our registered office in Thammanayakanahalli Village, Anekal Taluk, Bengaluru Urban District. Led by Managing Partner Deepika B, with partners D. Vadivelu and Papamma, we specialize in prospecting, exploring, operating, and processing mines and quarries to deliver high-quality natural stones and minerals.
                </p>
                <p>
                  At Bhoomi Rocks Products, we combine industry expertise with a commitment to quality and environmental responsibility, making us a trusted partner for transforming spaces with premium stones and minerals.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}